export default __webpack_public_path__ + "static/media/roadmap7.19eaf9f2.png";